const BLOCK_TAGS = "p,div,h1,h2,h3,h4,h5,h6,li,blockquote,pre";

/**
 * A message as plain-text lines: the first non-empty line, all of them, and whether anything follows the first.
 * Takes a parsed document so it runs in the browser (DOMParser) and on the server (jsdom).
 */
export function splitFirstLine(doc: Document) {
  doc.body.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
  doc.body.querySelectorAll(BLOCK_TAGS).forEach((el) => el.append("\n"));
  const lines = (doc.body.textContent ?? "")
    .split("\n")
    .map((line) => line.replace(/\s+/g, " ").trim())
    .filter(Boolean);
  const hasImage = Boolean(doc.body.querySelector("img"));
  return { firstLine: lines[0] ?? "", lines, hasMore: lines.length > 1 || hasImage };
}
